import React from "react"

import {FieldEditableMode, FieldEditableProps, FieldEditableState} from "../../../proto/render/editable"
import FieldIcon_Popover from "../components/popover/popover";
import {FieldViewSize} from "../../../const";
import FieldIcon_ValueNotEmpty from "../components/inline-edit/value-not-empty";

const debug = false
// const debug = "FieldIcon_Editable"

export default class FieldIcon_Editable extends React.Component<FieldEditableProps, FieldEditableState> {

    constructor(props:FieldEditableProps) {
        super(props)

        debug && console.log(debug, 'constructor', this.props)

        this.state = {
            mode: FieldEditableMode.VIEW
        }
    }

    get canEdit():boolean {
        return !(this.props.disabled || !this.props.field.canEdit(this.props.model));
    }

    get classes():string {
        return Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (this.state.mode === FieldEditableMode.VIEW) {
            this.setState({
                mode: FieldEditableMode.HOVERED
            })
        }
    }

    onMouseLeave = () => {
        if (this.state.mode === FieldEditableMode.HOVERED) {
            this.setState({
                mode: FieldEditableMode.VIEW
            })
        }
    }

    onOptionClick = (option: Option)=>{
        this.onChange(option.value as number)
    }

    onChange = async (value: number|null, hidePopover:boolean=true) => {
        // make it first (!) to update model and hidePopover will reRerender(!)
        this.props.onChange && this.props.onChange(value)

        hidePopover && this.hidePopover()
    }

    onClick = () => {
        if (!this.canEdit) return

        this.setState({
            mode: FieldEditableMode.EDITING
        })
    }

    hidePopover = () => {
        this.setState({
            mode: FieldEditableMode.VIEW
        })
    }

    getClasses = ()=> {

        const isHovered = [FieldEditableMode.EDITING, FieldEditableMode.HOVERED].includes(this.state.mode)

        return  Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
            "is-hovered"                    : isHovered
        })
    }

    renderHovered = ()=> {

        const showPopover = this.state.mode === FieldEditableMode.EDITING

        const value = this.props.field.getViewValue(this.props.model)

        return (
            <div className      = {this.getClasses()}
                 style          = {this.props.style}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}
                 onClick        = {this.onClick}>

                <FieldIcon_ValueNotEmpty className="m-r-5" value={value} field={this.props.field} onChange={this.onChange}/>

                <div className="btn-arrow"/>

                {showPopover &&
                    <FieldIcon_Popover parent       = {this}
                                       field        = {this.props.field}
                                       hidePopover  = {this.hidePopover}
                                       value        = {value}
                                       onChange     = {this.onChange}/>}
            </div>
        )
    }

    renderNotHovered = () => {

        const value = this.props.field.getViewValue(this.props.model)

        return (
            <div className      = {this.getClasses()}
                 style          = {this.props.style}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}
                 onClick        = {this.onClick}>

                <FieldIcon_ValueNotEmpty value={value} field={this.props.field} onChange={this.onChange}/>
            </div>
        )
    }

    render() {

        const isHovered = [FieldEditableMode.EDITING, FieldEditableMode.HOVERED].includes(this.state.mode)

        if (isHovered) {
            return this.renderHovered()
        } else {
            return this.renderNotHovered()
        }
    }
}



